import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-214" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance font-display text-4xl font-extrabold uppercase leading-[1.02] tracking-tight text-silver sm:text-5xl" data-id="element-215" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-5 flex w-fit items-center gap-1.5" aria-hidden="true" data-id="element-216" data-mp="mzzhfsi6ajvk">
        <span className="h-1 w-12 rounded-full bg-electric shadow-glow" data-id="element-217" data-mp="i6dggxldg4fl" />
        <span className="h-1 w-4 rounded-full bg-gold" data-id="element-218" data-mp="d83g88ksidn4" />
      </span>
    </div>;
}